<!-- EU: app-store links + QR "All Finished" page (beta onboarding reverted after EU app release) -->
<ng-container *ngIf="isEu">
  <p *ngIf="companyName">{{ "%leasingOrgName% will now verify your account." |T: {leasingOrgName: companyName} }}</p>
  <p>{{ "Once you’re verified, we’ll send you a confirmation email. You can use your ChargePoint account to charge at paid public stations." |T }}</p>
  <p>{{ "To find stations and manage your account, download the ChargePoint mobile app." |T }}</p>

  <div class="phone-container">
    <img class="phone-image" src="/assets/images/mobile_screenshot.png" alt="" />
  </div>
  <div class="pt-2 pb-4">
    <div class="mobile-app-buttons hidden-xs">
      <a (click)="clickDownload('apple')" class="mr-3" href="https://itunes.apple.com/app/apple-store/id356866743?pt=309768&amp;ct=Driver%20Mobile%20Web%20Page&amp;mt=8" target="_blank"><img src="/assets/images/i_app_ios_n.png"/></a>
      <a (click)="clickDownload('google')" href="https://play.google.com/store/apps/details?id=com.coulombtech&amp;referrer=utm_source%3DDriver%2520Mobile%26utm_medium%3DWeb%2520Page" target="_blank"><img src="/assets/images/i_app_android_n.png"/></a>
    </div>
  </div>
  <div class="qr-download text-center pb-4">
    <p class="qr-download__label">{{ "Or scan to download the app" |T }}</p>
    <qrcode
      [qrdata]="qrDownloadUrl"
      [width]="160"
      [margin]="1"
      [errorCorrectionLevel]="'M'"
      [elementType]="'img'"
      alt="Scan to download the ChargePoint app">
    </qrcode>
  </div>
  <div class="text-center pb-4 view-account" *ngIf="viewAccountUrl">
    <a [href]="viewAccountUrl">{{ "View Account" | T }}</a>
  </div>
</ng-container>

<!-- Non-EU (US/CA/etc.): original "All Finished" page -->
<ng-container *ngIf="!isEu">
  <p>{{"%leasingOrgName% is verifying your account. We’ll email you when your charging benefits are confirmed." |T: {leasingOrgName: companyName} }}</p>
  <p>
    {{"Download the free ChargePoint app to find stations." |T}}
  </p>
  <div class="phone-container">
    <img class="phone-image" src="/assets/images/ttc_phones.png" alt="" />
  </div>
  <div class="pt-2 pb-4">
    <div class="mobile-app-buttons hidden-xs">
      <a (click)="clickDownload('apple')" class="mr-3" href="https://itunes.apple.com/app/apple-store/id356866743?pt=309768&amp;ct=Driver%20Mobile%20Web%20Page&amp;mt=8" target="_blank"><img src="/assets/images/i_app_ios_n.png"/></a>
      <a (click)="clickDownload('google')" href="https://play.google.com/store/apps/details?id=com.coulombtech&amp;referrer=utm_source%3DDriver%2520Mobile%26utm_medium%3DWeb%2520Page" target="_blank"><img src="/assets/images/i_app_android_n.png"/></a>
    </div>
  </div>
</ng-container>
